export const measureSwitcher = (prevMeasure: 1 | 1_000 | 1_000_000) => {
  if (prevMeasure === 1_000_000) {
    return 1000;
  } else if (prevMeasure === 1_000) {
    return 1;
  } else {
    return 1_000_000;
  }
};
